module.exports = __webpack_public_path__ + "img/cylinderIcon.f8a908f8.jpeg";